export class WorkflowsRightMails {
  canCancelWorkflowInstance?: boolean;
  canDeleteWorkflowInstance?: boolean;
  canMoveToBac?: boolean;
  canResumeWorkflowInstance?: boolean;
  canRetryFaultedWorkflowInstance?: boolean;
  canStartWorkflowManually?: boolean;

  constructor(data?: Partial<WorkflowsRightMails>) {
    Object.assign(this, data);
  }
}
